import React from "react";

import { ReactComponent as IconSms } from "../../../../build/images/nps-dashboard-icons/icon-sms.svg";
import { ReactComponent as SMSICON } from "../../../../build/new-midias-icons/sms-icon.svg";
import { ReactComponent as IconEmail } from "../../../../build/images/nps-dashboard-icons/icon-email.svg";
import { ReactComponent as EMAILICON } from "../../../../build/new-midias-icons/email.svg";
import { ReactComponent as IconVoice } from "../../../../build/images/nps-dashboard-icons/icon-voice.svg";
import { ReactComponent as IconRcs } from "../../../../build/images/nps-dashboard-icons/icon-rcs.svg";
import { ReactComponent as IconWhatsapp } from "../../../../build/images/nps-dashboard-icons/icon-whatsapp.svg";

import "./card-channel-based.styles.css";

const CardChannelBased = ({ midiaId, sent, answered }) => {
  function renderIconByMidiaId(id) {
    switch (id) {
      case 15:
        return <IconRcs />;
      case 3:
        return <EMAILICON />;
      case 5:
        return <IconWhatsapp />;
      case 12:
        return <SMSICON />;
      default:
        return null;
    }
  }
  function renderNameMidiaByMidiaId(id) {
    switch (id) {
      case 15:
        return "rcs";
      case 3:
        return "email";
      case 5:
        return "whatsapp";
      case 12:
        return "sms";
      default:
        return "";
    }
  }
  return (
    <div className="card-channel-based-quality">
      <div
        className={`card-channel-based__icon ${renderNameMidiaByMidiaId(midiaId)}`}
      >
        {renderIconByMidiaId(midiaId)}
      </div>
      <div className="card-channel-based__values">
        <div className="card-channel-based__values__item">
          <div className="card-channel-based__values__item__number">{sent}</div>
          <span className="card-channel-based__values__item__text">
            Enviadas
          </span>
        </div>
        <div className="card-channel-based__values__item">
          <div className="card-channel-based__values__item__number">
            {answered}
          </div>
          <span className="card-channel-based__values__item__text">
            Respondidas
          </span>
        </div>
      </div>
    </div>
  );
};

export default CardChannelBased;
